// no itx for this file
import universalstorageHandler from "../persistence/UniversalstorageHandler";

export enum CheckPointNames {
  wireFuse = "wireFuse",
  wireTerminalToActor = "wireTerminal",
  wireTerminalToConsumer = "wireTerminalToConsumer",
  checkFuse = "checkFuse",
  checkTerminalToActor = "checkTerminal",
  checkTerminalToConsumer = "checkTerminalToConsumer",
  knxActor = "knxActor",
  knxRoom = "knxRoom",

  programmingPhysicalAddress = "prgAddress",
  programmingParameters = "prgParam",
}

export enum InstallationStates {
  unchecked,
  operational,
  faulty,
}

export class CheckPoint {
  private parentInstallChecks: InstallChecks;

  constructor(parentInstallChecks: InstallChecks) {
    console.log("constructor CheckPoint");
    this.parentInstallChecks = parentInstallChecks;
  }

  _checked = InstallationStates.unchecked;

  setChecked(newValue: InstallationStates, data?: any, dontSave?: boolean) {
    if (this._checked != newValue) {
      this._checked = newValue;
      this._checkedBy = state.loggedInUser?.name || "";
      this._checkDate = new Date();
      this._data = data;
      if (newValue == InstallationStates.operational) {
        this._comment == undefined;
      }

      if (!dontSave) {
        this.parentInstallChecks.save();
      }
    }
  }

  get checked(): InstallationStates {
    return this._checked;
  }

  _comment?: string;
  _checkedBy?: string;
  _checkDate?: Date;
  _data?: any;

  get comment(): string | undefined {
    return this._comment;
  }
  set comment(value: string | undefined) {
    this._comment = value;
    this.parentInstallChecks.save();
  }

  fromJSON(data: any) {
    if (data._checkDate) {
      //
      // Object to Date conversion
      //
      const dateFromServer = (data._checkDate = new Date(data._checkDate));

      const tThis = (this._checkDate && this._checkDate.getTime()) || 0;
      const tFromServer = dateFromServer.getTime();

      this.parentInstallChecks.merged ||= tThis != tFromServer;

      if (tThis > tFromServer) {
        //
        // dont load from json, if version in memory is newer
        //
        return;
      }
    }

    this._checked = data._checked;
    this._comment = data._comment;
    this._checkedBy = data._checkedBy;
    this._checkDate = data._checkDate;
    this._data = this._data;
  }

  toJSON(): any {
    const res = {
      _checked: this._checked,
      _comment: this._comment,
      _checkedBy: this._checkedBy,
      _checkDate: this._checkDate,
      _data: this._data,
    };
    return res;
  }
}

export class InstallChecks {
  ownerId: string;

  loadedTS: Date | undefined; // last lodingTime Timestamp
  merged: boolean = false;

  get lastModified(): Date | undefined {
    let res: Date | undefined;

    for (const cp of this.checkpoints) {
      if (cp._checkDate) {
        if (res) {
          if (res.getTime() < cp._checkDate.getTime()) {
            res = cp._checkDate;
          }
        } else {
          res = cp._checkDate;
        }
      }
    }

    return res;
  }

  constructor(ownerId: string) {
    this.ownerId = ownerId;
  }

  checkpoints: any = {};

  setChecked(checkPoint: CheckPointNames, newValue: InstallationStates, data?: any, dontSave?: boolean) {
    const cp = this.getCheckPoint(checkPoint);

    if (newValue == InstallationStates.operational) {
      if (checkPoint == CheckPointNames.knxRoom) {
        //
        // Wenn der Raumtest OK ist
        // dann sind auch die die folgenge Tests und Wirings  OK:
        //

        this.setChecked(CheckPointNames.wireTerminalToActor, InstallationStates.operational, true);
        this.setChecked(CheckPointNames.wireTerminalToConsumer, InstallationStates.operational, true);

        this.setChecked(CheckPointNames.checkTerminalToConsumer, InstallationStates.operational, true);
        this.setChecked(CheckPointNames.checkTerminalToActor, InstallationStates.operational, true);
        this.setChecked(CheckPointNames.knxActor, InstallationStates.operational, true);
      }
    }

    cp.setChecked(newValue, data, dontSave);
  }

  getChecked(checkPoint: CheckPointNames): InstallationStates {
    const cp = this.getCheckPoint(checkPoint);
    return cp.checked;
  }

  getData(checkPoint: CheckPointNames): any | undefined {
    const cp = this.getCheckPoint(checkPoint);
    return cp._data;
  }

  getCheckPoint(name: CheckPointNames): CheckPoint {
    let res: CheckPoint = this.checkpoints[name];
    if (!res) {
      res = new CheckPoint(this);
      this.checkpoints[name] = res;
    }

    return res;
  }

  toJSON(): any {
    const res = {
      ownerId: this.ownerId,
      checkpoints: {},
    };

    for (const i in this.checkpoints) {
      (res.checkpoints as any)[i] = this.checkpoints[i].toJSON();
    }

    return res;
  }

  fromJSON(data: any): void {
    this.ownerId = data.ownerId;
    this.merged = false;

    for (const i in data.checkpoints) {
      const checkPoint = this.checkpoints[i] || new CheckPoint(this);
      this.checkpoints[i] = checkPoint;
      checkPoint.fromJSON(data.checkpoints[i]);
    }
  }

  async save(saveOnlyLocal?: boolean): Promise<void> {
    await universalstorageHandler.saveInstallationChecks(
      state.projectMetadata.id,
      this.ownerId,
      this.toJSON(),
      saveOnlyLocal || false,
    );
  }

  async load(): Promise<void> {
    if (this.loadedTS) {
      const dt = Date.now() - this.loadedTS.getTime(); // in ms

      //
      // supress reloads during 10 seconds
      //

      if (dt < 10 * 1000) {
        console.log("skip load checkpoints");
        return;
      }
    }
    this.loadedTS = new Date();

    //
    // we load the data from the server AND from the localStorge
    // fromJSON will always take the newest version of every checkpoint
    //

    let lastModifiedFromServer: Date | undefined;


    const projectIsLoadedLocal = state.projectMetadata.loadedFrom == "local"

    let dataFromServer: any = undefined;

    if (!projectIsLoadedLocal) {
      dataFromServer = await universalstorageHandler.loadInstallationChecksFromServer(
        state.projectMetadata.id,
        this.ownerId,
      );
      if (dataFromServer) {
        this.fromJSON(dataFromServer);
        lastModifiedFromServer = this.lastModified;
      }
    }

    const dataFromLocalStorge = await universalstorageHandler.loadInstallationChecksFromLocalStorage(
      state.projectMetadata.id,
      this.ownerId,
    );
    if (dataFromLocalStorge) {
      this.fromJSON(dataFromLocalStorge);
    }

    if (!projectIsLoadedLocal) {
      if (this.merged || !dataFromLocalStorge || !dataFromServer) {
        //
        // if  is data is merged or missing local or on the sever
        // save the result back to localStorge AND (potentialy) server
        //

        let saveOnlyLocal = false;
        if (this.lastModified && lastModifiedFromServer) {
          saveOnlyLocal = lastModifiedFromServer.getTime() >= this.lastModified.getTime();
        }

        //
        // mwe to do 20.1.2025, avoid unnecessary save to server
        //
        await this.save(saveOnlyLocal);
      }
    }
  }
}
